module.exports = __webpack_public_path__ + "static/media/background-service-test.18fc3bee.svg";